// src/components/LoginPage.js
import React, { useState, useEffect } from "react";
import "./LoginPage.css";
import { db } from "../firebase";
import { ref, get, set } from "firebase/database";
import { useNavigate } from "react-router-dom";

export default function LoginPage() {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [sessionId, setSessionId] = useState("");
  const [statusMessage, setStatusMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const uid = localStorage.getItem("uid");
    if (uid) navigate("/home");
  }, []);

  const SEND_OTP_URL = "https://api.shooinstars.in/send-otp";
  const VERIFY_OTP_URL = "https://api.shooinstars.in/verify-otp";

  const sendOtp = async (e) => {
    e.preventDefault();

    if (phone.length !== 10) return alert("Enter valid phone number");
    if (!name.trim()) return alert("Enter your name");

    try {
      setLoading(true);
      setStatusMessage("Sending OTP to your WhatsApp...");

      const res = await fetch(SEND_OTP_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone, name }),
      });

      const data = await res.json();

      setSessionId(data.session_id);
      setIsOtpSent(true);
      setStatusMessage("OTP has been sent to your WhatsApp.");

    } catch {
      setStatusMessage("Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = async (e) => {
    e.preventDefault();

    if (otp.length !== 6) return alert("Enter valid 6-digit OTP");

    try {
      setLoading(true);
      setStatusMessage("Verifying OTP...");

      const res = await fetch(VERIFY_OTP_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ session_id: sessionId, otp }),
      });

      const data = await res.json();

      if (!res.ok || !data.success) {
        setStatusMessage(data.error || "Invalid OTP.");
        setLoading(false);
        return;
      }

      const uid = data.uid;

      const userData = {
        uid,
        name,
        mobile: "91" + phone,
      };

      localStorage.setItem("user", JSON.stringify(userData));
      localStorage.setItem("uid", uid);

      await initUserIfNeeded(uid);

      navigate("/home");
    } catch {
      setStatusMessage("OTP verification failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const initUserIfNeeded = async (uid) => {
    const userRef = ref(db, "users/" + uid);
    const snap = await get(userRef);

    if (!snap.exists()) {
      await set(userRef, {
        phone: "91" + phone,
        name,
        is_premium: false,
        premium_joined_at: 0,
        premium_expiry: 0,
        usage: {
          preference_form: { used: 0, free_limit: 1, premium_limit: 3 },
          college_predictor: { used: 0, free_limit: 1, premium_limit: 3 },
        },
      });
    }
  };

  return (
    <div className="login-container">
      <form className="login-box">

        {/* BRAND TITLE */}
        <h1 className="brand-title">Shooin Stars</h1>

        <h2 className="login-title">Login</h2>

        {/* STATUS MESSAGE */}
        {statusMessage && (
          <p className="status-message">{statusMessage}</p>
        )}

        {!isOtpSent && (
          <>
            <label>Name</label>
            <input
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />

            <label>Phone Number</label>
            <input
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
  placeholder="Enter phone number"
  value={phone}
  onChange={(e) =>
    setPhone(e.target.value.replace(/\D/g, "").slice(0, 10))
  }
/>

          </>
        )}

        {isOtpSent && (
          <>
            <label>Enter OTP</label>
            <input
  type="text"
  inputMode="numeric"
  pattern="[0-9]*"
  placeholder="Enter OTP"
  value={otp}
  onChange={(e) =>
    setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))
  }
/>

            <p className="resend" onClick={sendOtp}>
              Resend OTP
            </p>
          </>
        )}

        <button
          className="login-button"
          disabled={loading}
          onClick={isOtpSent ? verifyOtp : sendOtp}
        >
          {loading
            ? "Please wait..."
            : isOtpSent
            ? "Verify OTP"
            : "Send OTP on WhatsApp"}
        </button>
      </form>
    </div>
  );
}
